import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { CheckboxOptionType } from 'antd/es/checkbox';
import { Row, Col, Checkbox, Input } from '@fuxi/eevee-ui';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export interface DiscoveryValue {
  values: number[];
  hasYtActivity: boolean;
  ytActivity: string;
  hasSpeech: boolean;
  speech: string;
  hasOther: boolean;
  other: string;
  recommend: string;
  hasRecommend: boolean;
}

interface DiscoveryProps {
  value?: DiscoveryValue;
  onChange?: (value: Partial<DiscoveryValue>) => void;
}

const DiscoveryItems: React.FC<DiscoveryProps> = ({
  value = {
    values: [],
    hasYtActivity: false,
    ytActivity: '',
    hasSpeech: false,
    speech: '',
    hasOther: false,
    other: '',
    hasRecommend: false,
    recommend: '',
  },
  onChange,
}) => {
  const { t } = useTranslation();
  const [hasYtActivity, setHasYtActivity] = useState(false);
  const [hasSpeech, setHasSpeech] = useState(false);
  const [hasOther, setHasOther] = useState(false);
  const [hasRecommend, setHasRecommend] = useState(false);

  const checkOptions: CheckboxOptionType[] = [3].map(item => ({
    label: t(`consultForm.knownFrom.answer${item}`),
    value: item,
  }));

  const triggerChange = (changedValue: Partial<DiscoveryValue>) => {
    onChange?.({ ...value, ...changedValue });
  };

  const onCheckboxGroupChange = (checkedValue: Array<CheckboxValueType>) => {
    triggerChange({ values: checkedValue as number[] });
  };

  return (
    <Row gutter={[24, 16]}>
      <Col span={24}>
        <div className={cx('input-line')}>
          <Checkbox
            checked={hasYtActivity}
            onChange={e => {
              setHasYtActivity(e.target.checked);
              triggerChange({ hasYtActivity: e.target.checked });
            }}>
            {t('consultForm.knownFrom.answer1')}
          </Checkbox>
          <Input
            hidden={!hasYtActivity}
            className="input"
            style={{ width: 296 }}
            placeholder={t('consultForm.knownFrom.placeholder1')}
            autoComplete="off"
            onChange={e => {
              triggerChange({ ytActivity: e.target.value });
            }}
          />
        </div>
      </Col>
      <Col span={24}>
        <div className={cx('input-line')}>
          <Checkbox
            checked={hasSpeech}
            onChange={e => {
              setHasSpeech(e.target.checked);
              triggerChange({ hasSpeech: e.target.checked });
            }}>
            {t('consultForm.knownFrom.answer2')}
          </Checkbox>
          <Input
            hidden={!hasSpeech}
            className="input"
            style={{ width: 296 }}
            placeholder={t('consultForm.knownFrom.placeholder3')}
            autoComplete="off"
            onChange={e => {
              triggerChange({ speech: e.target.value });
            }}
          />
        </div>
      </Col>
      <Col span={24}>
        <Checkbox.Group onChange={onCheckboxGroupChange}>
          <Row gutter={[24, 16]}>
            {checkOptions.map((item: CheckboxOptionType, idx) => (
              <Col span={24} key={idx}>
                <Checkbox value={item.value}>{item.label}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Col>
      <Col span={24}>
        <div className={cx('input-line')}>
          <Checkbox
            checked={hasRecommend}
            onChange={e => {
              setHasRecommend(e.target.checked);
              triggerChange({ hasRecommend: e.target.checked });
            }}>
            {t('consultForm.knownFrom.answer4')}
          </Checkbox>
          <Input
            hidden={!hasRecommend}
            className="input"
            style={{ width: 296 }}
            placeholder={t('consultForm.knownFrom.placeholder4')}
            autoComplete="off"
            onChange={e => {
              triggerChange({ recommend: e.target.value });
            }}
          />
        </div>
      </Col>
      <Col span={24}>
        <div className={cx('input-line')}>
          <Checkbox
            checked={hasOther}
            onChange={e => {
              setHasOther(e.target.checked);
              triggerChange({ hasOther: e.target.checked });
            }}>
            {t('consultForm.other')}
          </Checkbox>
          <Input
            hidden={!hasOther}
            className="input"
            style={{ width: 296 }}
            placeholder={t('consultForm.knownFrom.placeholder2')}
            autoComplete="off"
            onChange={e => {
              triggerChange({ other: e.target.value });
            }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default DiscoveryItems;
